<template>
  <div>
    <div class="resbox">
      <div class="up">
        <img class="img" src="../../../assets/img/error.png" alt />
        <div class="res">抱歉，支付失败</div>
        <div class="why">可能原因：交易无效，无法完成，支付失败</div>
        <div class="btns"></div>
      </div>
      <div class="tip">温馨提示：如遇扣款成功，却支付失败，请与客服人员联系</div>
      <div class="contact">客服电话：010-65185898 | +86 15210925572</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  created() {},
  methods: {
    goHome() {
      // 进入数据库首页
      let url;
      if (process.env.NODE_ENV == "production") {
        url = `http://lightdata.tjresearch.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      } else {
        url = `http://macro.tj.cn/#/macro?userInfo=${JSON.stringify(
          this.userInfo
        )}&auth=${encodeURIComponent(this.authorization)}&moduleId=2`;
      }
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.res-dialog {
  .resbox {
    text-align: center;
    .up {
      margin-bottom: 30px;
      .code {
        width: 100px;
        height: 100px;
      }
      .res {
        font-weight: 500;
        font-size: 24px;
        margin: 20px;
        color: #414141;
      }
      .why {
        color: #999999;
        font-size: 12px;
        margin-bottom: 20px;
        .home {
          color: #ff6908;
          cursor: pointer;
        }
      }
      .btns {
        margin-top: 50px;
        .el-button {
          width: 130px;
          height: 26px;
          line-height: 0;
          font-size: 12px;
        }
      }
    }
    .tip {
      height: 44px;
      line-height: 44px;
      margin: 0 50px;
      color: #aa956e;
      background: #fbf8e5;
      border: 1px solid #f0f0ec;
      font-size: 12px;
    }
    .contact {
      margin-top: 30px;
      font-size: 12px;
    }
  }
}
</style>